import { Box, Button, Flex, Input, Menu, Select, Tabs, Text } from "@mantine/core";
import DraftNotesTab from "../../../components/DraftNotesTab";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import NoteTypeSelectModal from "../../../components/NoteSelectTypeModal";
import NoteTable from "../../../components/NoteTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { getAllFacilitiesModal, getAllFacilityTypes } from "../../../services";
import {
  getAllNoteTypes,
  getNotes,
  getSingleNote,
} from "../../../services/note";
import { getAllPatientsModal } from "../../../services/patient";
import { getAllStaff } from "../../../services/staff";
import { getAllPlans } from "../../../services/supportplan";
import { DatePickerInput } from "@mantine/dates";
import moment from "moment";
import useStyles from "./style";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AddEssentialNote from "../../../components/AddEssentialNote/AddEssentialNote";
import { Billing_Services_Note, Essential_Support_Note } from "../../../http";
import { getBillingProvider } from "../../../services/billingprovider";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import NoteDrawer from "../../../components/NoteModal/NewNoteDesignCopy";
import { IoChevronBack, IoFilter, IoSettingsOutline } from "react-icons/io5";
import { NewAddButton } from "../../../components/AddButton/NewAddButton";
import { NotetTypeSvg } from "../../../components/Svgs/NotetTypeSvg";
import { RxCross2 } from "react-icons/rx";
import { IconSearch } from "@tabler/icons-react";
import useDebounce from "../../../utils/useDebounce";
import { clearNotes } from "../../../store/reducers/note";
import { FaSort } from "react-icons/fa6";
import { getSkaiTokenUsage } from "../../../services/skaiTokens";
import { PDFDownloadLink } from "@react-pdf/renderer";
import NoteReportPDF from "../../../components/NoteReportPDF";
import { ReportSvg } from "../../../components/Svgs/ReportSvg";
import NoteReportDrawer from "../../../components/NoteReportModal";
import { getAllSignatures } from "../../../services/signature";
import NoteModalNew from "../../../components/NoteModal/NoteModalNew";
import ServiceDeliveryLogPdf from "../../../components/ServiceDeliveryLogPdf";

const Note = (props) => {
  const { notes, loading } = useSelector((state) => state?.note);
  const { singleNote } = useSelector((state) => state?.note);
  const { profile } = useSelector((state) => state.profile);
  const [data, setData] = useState(null);
  const [view, setView] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [isViewNoteOpen, setIsViewNoteOpen] = useState(false);
  const [noteType, setNoteType] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [dateRangeVal, setDateRangeVal] = useState([]);
  const [opened, { open, close }] = useDisclosure(false);
  const [oneDayValue, setOneDayValue] = useState(null);
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("descending");
  const [openModal, setOpenModal] = useState(false);
  const [billingServices, setBillingServices] = useState("");
  const [progressNoteState, setProgressNoteState] = useState("");
  const [resetPatientTrigger, setResetPatientTrigger] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [
    noteReportDrawerOpened,
    { open: noteReportDrawerOpen, close: noteReportDrawerClose },
  ] = useDisclosure(false);
  const [activeFilters, setActiveFilters] = useState({
    facility: null,
    createdBy: null,
    noteTypeFilter: null,
    client: null,
  });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [tempFacility, setTempFacility] = useState(null);
  const [tempCreatedBy, setTempCreatedBy] = useState(null);
  const [tempNoteType, setTempNoteType] = useState(null);
  const [tempClient, setTempClient] = useState(null);
  const [draftUserId, setDraftUserId] = useState(null);
  const navigate = useNavigate();

  const handleEditDraft = (draft) => {
    setNoteType(draft.noteType?._id || draft.noteType);
    setDraftUserId(draft.client?._id || draft.client);
    setOpen(true);
  };
  const { classes } = useStyles();

  const { allDeletedFacilities } = useSelector((state) => state?.facility);
  const { allStaff } = useSelector((state) => state?.staff);
  const { allNotesTypes } = useSelector((state) => state?.note);
  const { allPatients } = useSelector((state) => state?.patient);

  const debouncedSearch = useDebounce(searchTerm, 2000);

  useEffect(() => {
    if (debouncedSearch) {
      getNotes(
        currentPage,
        null,
        true,
        dateRange,
        sortField,
        sortOrder,
        debouncedSearch,
        activeFilters,
      );
    } else {
      getNotes(
        currentPage,
        null,
        true,
        dateRange,
        sortField,
        sortOrder,
        undefined,
        activeFilters,
      );
    }
  }, [debouncedSearch]);

  useEffect(() => {
    getAllPlans();
    getAllNoteTypes();
    getAllFacilityTypes();
    getAllPatientsModal("withDeleted");
    getAllFacilitiesModal("withDeleted");
    getAllStaff("all");
    getBillingProvider();
    getAllSignatures();

    TrackPageView("Note");
  }, []);

  useEffect(() => {
    getNotes(
      currentPage,
      null,
      true,
      dateRange,
      sortField,
      sortOrder,
      undefined,
      activeFilters,
    );
  }, [currentPage, dateRange, activeFilters]);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearNotes());
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const noteId = params.get("noteId");
    if (noteId) {
      getSingleNote(noteId);
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    if (singleNote) {
      setData(singleNote);
    }
  }, [singleNote]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDateRange = (dates) => {
    if (dates[0] == null && dates[1] == null) {
      setDateRangeVal([]);
    } else {
      setDateRangeVal(dates);
    }
  };

  const handleDateChange = (date) => {
    setOneDayValue(date);
  };

  const handleSaveDateRange = () => {
    if (dateRangeVal?.length) {
      let startDate = moment(dateRangeVal[0]).startOf("day");
      let endDate = moment(dateRangeVal[1]).endOf("day");
      setDateRange([startDate, endDate]);
    } else if (oneDayValue) {
      let startDate = moment(oneDayValue).startOf("day");
      let endDate = moment(oneDayValue).endOf("day");
      setDateRange([startDate, endDate]);
    }
    setDropdownOpen(false);
  };

  const handleSaveSort = () => {
    getNotes(
      currentPage,
      null,
      true,
      dateRange,
      sortField,
      sortOrder,
      undefined,
      activeFilters,
    );
    setSortOpen(false);
  };

  const handleSortChange = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  const handleCancelDateRange = () => {
    setDateRangeVal([]);
    setDateRange(null);
    setDropdownOpen(false);
  };

  const handleResetSort = () => {
    setSortField("createdAt");
    setSortOrder("descending");
    getNotes(
      currentPage,
      null,
      true,
      dateRange,
      "createdAt",
      "descending",
      undefined,
      activeFilters,
    );
    setSortOpen(false);
  };

  const hasActiveFilters =
    activeFilters?.facility ||
    activeFilters?.createdBy ||
    activeFilters?.noteTypeFilter ||
    activeFilters?.client ||
    dateRange;

  const getFacilityName = (id) => {
    const fac = allDeletedFacilities?.facilities?.find((f) => f.id === id);
    return fac?.name || id;
  };

  const getStaffName = (id) => {
    const staff = allStaff?.find((s) => s?.id === id);
    return (
      staff?.name ||
      `${staff?.firstName || ""} ${staff?.lastName || ""}`.trim() ||
      id
    );
  };

  const getNoteTypeName = (id) => {
    const nt = allNotesTypes?.ntypes?.find((n) => n?.id === id);
    return nt?.name || id;
  };

  const getClientName = (id) => {
    const patient = allPatients?.find((p) => p?.id === id);
    return patient?.name || id;
  };

  const handleApplyFilter = () => {
    const newFilters = { ...activeFilters };
    if (selectedCategory === "facility" && tempFacility) {
      newFilters.facility = tempFacility;
    }
    if (selectedCategory === "staff" && tempCreatedBy) {
      newFilters.createdBy = tempCreatedBy;
    }
    if (selectedCategory === "noteType" && tempNoteType) {
      newFilters.noteTypeFilter = tempNoteType;
    }
    if (selectedCategory === "client" && tempClient) {
      newFilters.client = tempClient;
    }
    if (selectedCategory === "date") {
      handleSaveDateRange();
    }
    setActiveFilters(newFilters);
    setCurrentPage(1);
    setDropdownOpen(false);
    setSelectedCategory(null);
  };

  const handleResetAllFilters = () => {
    setActiveFilters({
      facility: null,
      createdBy: null,
      noteTypeFilter: null,
      client: null,
    });
    setDateRange(null);
    setDateRangeVal([]);
    setOneDayValue(null);
    setTempFacility(null);
    setTempCreatedBy(null);
    setTempNoteType(null);
    setTempClient(null);
    setSelectedCategory(null);
    setCurrentPage(1);
    setDropdownOpen(false);
  };

  const handleRemoveFilter = (key) => {
    if (key === "date") {
      setDateRange(null);
      setDateRangeVal([]);
      setOneDayValue(null);
      setCurrentPage(1);
    } else {
      setActiveFilters((prev) => ({ ...prev, [key]: null }));
      setCurrentPage(1);
    }
  };

  const handleAddEssential = () => {
    if (billingServices) {
      setNoteType(Billing_Services_Note);
    } else {
      setNoteType(Essential_Support_Note);
    }
    setOpen(true);
  };

  return (
    <Box fluid className={classes.content}>
      <AddEssentialNote
        openModal={openModal}
        setOpenModal={setOpenModal}
        onConfirm={handleAddEssential}
        billingServices={billingServices}
        setBillingServices={setBillingServices}
        onAddLater={() => {
          setResetPatientTrigger((c) => c + 1);
          setProgressNoteState("");
        }}
      />
      <NoteDrawer
        data={data}
        // view={view}
        opened={isopen}
        // setView={setView}
        noteType={noteType}
        userId={draftUserId}
        autoRestoreDraft={!!draftUserId}
        title={"Add New Note"}
        close={() => {
          setOpen(false);
          setData(null);
          setNoteType();
          setDraftUserId(null);
        }}
        sortField={sortField}
        sortOrder={sortOrder}
        setOpenModal={setOpenModal}
        setBillingServices={setBillingServices}
        setProgressNoteState={setProgressNoteState}
        progressNoteState={progressNoteState}
        resetPatientTrigger={resetPatientTrigger}
      />

      <NoteModalNew
        opened={isViewNoteOpen}
        close={() => {
          setIsViewNoteOpen(false);
          setData(null);
        }}
        hideApproveRejectButtons={true}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      />

      <AppNavbar title={"Note"} profile={profile} />

      <Tabs defaultValue="all-notes" px={20} mx={20} styles={{ tab: { "&[data-active]": { borderColor: "#000", color: "#000" } } }}>
      <Box className={classes.btn}>
        <Flex align="center" gap={8}>
          <Tabs.List>
            <Tabs.Tab value="all-notes">All Notes</Tabs.Tab>
            <Tabs.Tab value="drafts">Saved Drafts</Tabs.Tab>
          </Tabs.List>
          {/* Sorting */}
          <Box className={classes.rightBTN}>
            <Menu
              width={350}
              shadow="md"
              radius={"md"}
              opened={sortOpen}
              position="bottom-start"
              onClose={() => setSortOpen(false)}
            >
              <Menu.Target title="Sort">
                <Box
                  className={classes.FilterIcon}
                  onClick={() => setSortOpen(!sortOpen)}
                >
                  <FaSort size={30} />
                </Box>
              </Menu.Target>

              <Menu.Dropdown>
                <Box className={classes.box_header}>
                  <Text size="md" weight={500} mt={10} mb={5}>
                    Sorting
                  </Text>
                  <Button variant="unstyled" p={0} onClick={handleResetSort}>
                    <RxCross2 />
                  </Button>
                </Box>
                <Box className={classes.box_body}>
                  <Select
                    label="Sort By"
                    placeholder="Sort by"
                    data={[
                      { label: "Created Date", value: "createdAt" },
                      { label: "Note Date", value: "noteDate" },
                      { label: "Edited Date", value: "updatedAt" },
                    ]}
                    value={sortField}
                    onChange={(value) => handleSortChange(value, sortOrder)}
                  />
                  <Select
                    label="Sort Order"
                    placeholder="Sort Order"
                    data={[
                      { label: "Ascending", value: "ascending" },
                      { label: "Descending", value: "descending" },
                    ]}
                    value={sortOrder}
                    onChange={(value) => handleSortChange(sortField, value)}
                  />
                </Box>
                <Box className={classes.btn_container}>
                  <Button
                    size="sm"
                    radius={"md"}
                    color="gray"
                    variant="outline"
                    onClick={handleResetSort}
                  >
                    Reset
                  </Button>
                  <Button
                    size="sm"
                    radius={"md"}
                    // color="yellow"
                    disabled={loading}
                    onClick={handleSaveSort}
                    style={{
                      backgroundColor: "#000",
                    }}
                  >
                    Save
                  </Button>
                </Box>
              </Menu.Dropdown>
            </Menu>
          </Box>
        </Flex>
        <Box className={classes.rightBTN}>

          {/* <PDFDownloadLink
            document={<ServiceDeliveryLogPdf />}
            fileName="service-delivery-log.pdf"
            style={{
              backgroundColor: "#2563eb",
              color: "white",
              padding: "12px 24px",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "16px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              transition: "all 0.2s",
              cursor: "pointer",
            }}
          >
            {({ blob, url, loading, error }) =>
              "Download PDF"
            }
          </PDFDownloadLink> */}
          {/* filter */}
          <Menu
            width={350}
            shadow="md"
            radius={"md"}
            opened={dropdownOpen}
            position="bottom"
            onClose={() => {
              setDropdownOpen(false);
              setSelectedCategory(null);
            }}
          >
            <Menu.Target title="Filter">
              <Button
                size="md"
                radius="md"
                title="Filter"
                leftIcon={<IoFilter />}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                color="gray"
                variant="outline"
              >
                Filter
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              {!selectedCategory ? (
                <>
                  <Box className={classes.box_header}>
                    <Text size="lg" weight={500}>
                      Filter
                    </Text>
                    <Button
                      variant="unstyled"
                      p={0}
                      onClick={() => setDropdownOpen(false)}
                    >
                      <RxCross2 />
                    </Button>
                  </Box>
                  <Box className={classes.filterCategoryList}>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("facility");
                        setTempFacility(activeFilters.facility);
                      }}
                    >
                      <Text>Facility</Text>
                      {activeFilters.facility && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("client");
                        setTempClient(activeFilters.client);
                      }}
                    >
                      <Text>Client Name</Text>
                      {activeFilters.client && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("staff");
                        setTempCreatedBy(activeFilters.createdBy);
                      }}
                    >
                      <Text>Staff Name</Text>
                      {activeFilters.createdBy && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("noteType");
                        setTempNoteType(activeFilters.noteTypeFilter);
                      }}
                    >
                      <Text>Note Type</Text>
                      {activeFilters.noteTypeFilter && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => setSelectedCategory("date")}
                    >
                      <Text>Date</Text>
                      {dateRange && <Box className={classes.activeFilterDot} />}
                    </Box>
                  </Box>
                  <Box className={classes.btn_container}>
                    <Button
                      size="sm"
                      radius={"md"}
                      color="gray"
                      variant="outline"
                      onClick={handleResetAllFilters}
                    >
                      Reset All
                    </Button>
                  </Box>
                </>
              ) : (
                <>
                  <Box
                    className={classes.filterCategoryHeader}
                    onClick={() => setSelectedCategory(null)}
                  >
                    <IoChevronBack size={16} />
                    <Text weight={600}>
                      {selectedCategory === "facility" && "Facility"}
                      {selectedCategory === "client" && "Client Name"}
                      {selectedCategory === "staff" && "Staff Name"}
                      {selectedCategory === "noteType" && "Note Type"}
                      {selectedCategory === "date" && "Date"}
                    </Text>
                  </Box>
                  <Box className={classes.box_body}>
                    {selectedCategory === "facility" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Facility"
                          placeholder="Search facility..."
                          searchable
                          clearable
                          value={tempFacility}
                          onChange={setTempFacility}
                          data={
                            allDeletedFacilities
                            ?.facilities
                             ?.filter(
                                (p) => p?.active === true && p?.deleted === false,
                              )
                            ?.map((f) => ({
                              label: f?.name,
                              value: f?.id,
                            })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "client" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Client"
                          placeholder="Search client..."
                          searchable
                          clearable
                          value={tempClient}
                          onChange={setTempClient}
                          data={
                            allPatients
                              ?.filter(
                                (p) => p?.active === true && p?.deleted === false,
                              )
                              ?.map((p) => ({
                                label: p?.name || "Unknown",
                                value: p?.id,
                              })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "staff" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Staff"
                          placeholder="Search staff..."
                          searchable
                          clearable
                          value={tempCreatedBy}
                          onChange={setTempCreatedBy}
                          data={
                            allStaff
                            ?.filter(
                                (p) => p?.active === true && p?.deleted === false,
                              )
                            ?.map((s) => ({
                              label:
                                s?.name ||
                                `${s?.firstName || ""} ${s?.lastName || ""}`.trim(),
                              value: s?.id,
                            })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "noteType" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Note Type"
                          placeholder="Search note type..."
                          searchable
                          clearable
                          value={tempNoteType}
                          onChange={setTempNoteType}
                          data={
                            allNotesTypes?.ntypes?.map((n) => ({
                              label: n?.name,
                              value: n?.id,
                            })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "date" && (
                      <>
                        <Box className={classes.filterFields}>
                          <DatePickerInput
                            size="sm"
                            radius={"md"}
                            clearable
                            type="range"
                            value={dateRangeVal}
                            disabled={oneDayValue}
                            label="Select Date Range"
                            onChange={handleDateRange}
                            placeholder="Select Date Range"
                          />
                        </Box>
                        <Box className={classes.filterFields}>
                          <DatePickerInput
                            radius={"md"}
                            clearable
                            size="sm"
                            value={oneDayValue}
                            label="Select Date"
                            placeholder="Select Date"
                            onChange={handleDateChange}
                            disabled={dateRangeVal?.length}
                          />
                        </Box>
                      </>
                    )}
                  </Box>
                  <Box className={classes.btn_container}>
                    <Button
                      size="sm"
                      radius={"md"}
                      color="gray"
                      variant="outline"
                      onClick={() => {
                        if (selectedCategory === "facility")
                          setTempFacility(null);
                        if (selectedCategory === "client") setTempClient(null);
                        if (selectedCategory === "staff")
                          setTempCreatedBy(null);
                        if (selectedCategory === "noteType")
                          setTempNoteType(null);
                        if (selectedCategory === "date") {
                          setDateRangeVal([]);
                          setOneDayValue(null);
                        }
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      radius={"md"}
                      size="sm"
                      disabled={loading}
                      onClick={handleApplyFilter}
                      style={{
                        backgroundColor: "#000",
                      }}
                    >
                      Apply
                    </Button>
                  </Box>
                </>
              )}
            </Menu.Dropdown>
          </Menu>
          <NewAddButton
            title="Add Note"
            icon={<NotetTypeSvg />}
            onClick={() => {
              getAllStaff("all");
              setOpen(true);
            }}
            color="#FFAF4A"
            textColor="#000"
            variant="filled"
            borderColor="none"
          />
          <NewAddButton
            title="Create Report"
            icon={<ReportSvg />}
            onClick={noteReportDrawerOpen}
            color="#FFAF4A"
            textColor="#000"
            variant="filled"
            borderColor="none"
          />

          {profile?.user?.type !== "staff" &&
            profile?.user?.role !== "staff" &&
            profile?.user?.role !== "admin" && (
              <NewAddButton
                title="Settings"
                icon={<IoSettingsOutline />}
                onClick={() => navigate("/home/notetype")}
                color="#000"
                textColor="#fff"
                variant="filled"
                borderColor="none"
              />
            )}
        </Box>
      </Box>

        <Tabs.Panel value="all-notes" mt={8}>
          <Box className={classes.search_container}>
            <Input
              icon={<IconSearch />}
              placeholder="Search"
              className={classes.searchInput}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>
          {hasActiveFilters && (
            <Box className={classes.activeFiltersBar}>
              {activeFilters.facility && (
                <Box className={classes.filterChip}>
                  <Text size="xs">
                    Facility: {getFacilityName(activeFilters.facility)}
                  </Text>
                  <RxCross2
                    size={12}
                    onClick={() => handleRemoveFilter("facility")}
                  />
                </Box>
              )}
              {activeFilters.client && (
                <Box className={classes.filterChip}>
                  <Text size="xs">
                    Client: {getClientName(activeFilters.client)}
                  </Text>
                  <RxCross2
                    size={12}
                    onClick={() => handleRemoveFilter("client")}
                  />
                </Box>
              )}
              {activeFilters.createdBy && (
                <Box className={classes.filterChip}>
                  <Text size="xs">
                    Staff: {getStaffName(activeFilters.createdBy)}
                  </Text>
                  <RxCross2
                    size={12}
                    onClick={() => handleRemoveFilter("createdBy")}
                  />
                </Box>
              )}
              {activeFilters.noteTypeFilter && (
                <Box className={classes.filterChip}>
                  <Text size="xs">
                    Note Type: {getNoteTypeName(activeFilters.noteTypeFilter)}
                  </Text>
                  <RxCross2
                    size={12}
                    onClick={() => handleRemoveFilter("noteTypeFilter")}
                  />
                </Box>
              )}
              {dateRange && (
                <Box className={classes.filterChip}>
                  <Text size="xs">
                    Date: {moment(dateRange[0]).format("MM/DD/YY")} -{" "}
                    {moment(dateRange[1]).format("MM/DD/YY")}
                  </Text>
                  <RxCross2 size={12} onClick={() => handleRemoveFilter("date")} />
                </Box>
              )}
              <Text
                className={classes.clearAllLink}
                onClick={handleResetAllFilters}
              >
                Clear all
              </Text>
            </Box>
          )}
          <Box className={classes.noteTable}>
            <NoteTable
              openModal={(data) => {
                setView(false);
                setData(data);
                setOpen(true);
              }}
              openViewModal={(data) => {
                setData(data);
                setIsViewNoteOpen(true);
              }}
              setView={(data) => {
                setView(true);
              }}
              sortField={sortField}
              sortOrder={sortOrder}
              setOpenModal={setOpenModal}
              setOpen={setOpen}
            />
            {notes?.notes?.length > 0 ? (
              <CustomPagination
                itemsPerPage={10}
                data={notes?.count}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
              />
            ) : (
              ""
            )}
            <NoteTypeSelectModal
              save={setOpen}
              opened={opened}
              title={"Add Note"}
              onclose={(nType) => {
                close();
                setNoteType(nType);
              }}
            />
            <NoteReportDrawer
              drawerOpen={noteReportDrawerOpened}
              drawerClose={noteReportDrawerClose}
            />
          </Box>
        </Tabs.Panel>

        <Tabs.Panel value="drafts" pt={8}>
          <DraftNotesTab onEditDraft={handleEditDraft} />
        </Tabs.Panel>
      </Tabs>
    </Box>
  );
};

export default Note;
